import { Component, inject, OnDestroy, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PDFDocumentProxy, PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { MatButtonModule } from '@angular/material/button';

interface PDFOutline {
  title: string;
  bold: boolean;
  italic: boolean;
  color: Uint8ClampedArray;
  dest: string | any[] | null;
  url: string | null;
  unsafeUrl: string | undefined;
  newWindow: boolean | undefined;
  count: number | undefined;
  items: any[];
}

@Component({
  selector: 'app-pdf-preview-dialog',
  templateUrl: 'pdf-preview-dialog.component.html',
  styleUrls: ['pdf-preview-dialog.component.scss'],
  imports: [MatDialogModule, MatToolbarModule, MatIconModule, PdfViewerModule, MatButtonModule],
})
export class PDFPreviewDialogComponent implements OnDestroy {
  title!: string;
  src!: string;
  outline: PDFOutline[] | null = null;
  zoom = 1;
  rotation = 0;
  pdf!: PDFDocumentProxy;
  @ViewChild(PdfViewerComponent) private pdfComponent!: PdfViewerComponent;

  constructor() {
    const data = inject<{
      pdf: Blob;
      title: string;
    }>(MAT_DIALOG_DATA);

    this.src = URL.createObjectURL(data.pdf);
    this.title = data.title;
  }

  async afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pdf = pdf;
    this.pdf.getOutline().then((outline: PDFOutline[]) => {
      this.outline = outline?.length ? outline : null;
    });
    const el = this.pdfComponent.pdfViewerContainer.nativeElement;
    setTimeout(() => el?.scrollBy({ top: -100, behavior: 'smooth' }), 200);
  }

  ngOnDestroy() {
    URL.revokeObjectURL(this.src);
  }

  async navigateTo(destination: any) {
    await this.pdfComponent.pdfLinkService.goToDestination(destination);
  }

  zoomIn() {
    this.zoom = Math.min(2, this.zoom + 0.1);
  }

  zoomOut() {
    this.zoom = Math.max(0.5, this.zoom - 0.1);
  }

  rotateLeft() {
    this.rotation = (this.rotation + 270) % 360;
  }

  rotateRight() {
    this.rotation = (this.rotation + 90) % 360;
  }
}
